import { useState, useEffect } from 'react';
import styles from './FloatingCta.module.css';
import FormModal from '../formModal/FormModal';
import proof1 from '../../images/students_certificate_1.webp';
import proof2 from '../../images/students_certificate_2.webp';
import proof3 from '../../images/students_certificate_3.webp';
import proof4 from '../../images/students_certificate_4.webp';
import proof5 from '../../images/students_certificate_5.webp';
import proof6 from '../../images/students_certificate_6.webp';
import proof7 from '../../images/students_certificate_7.webp';
import proof8 from '../../images/students_certificate_8.webp';
import proof9 from '../../images/students_certificate_9.webp';
import proof10 from '../../images/students_certificate_10.webp';

const proofImages = [proof1, proof2, proof3, proof4, proof5, proof6, proof7, proof8, proof9, proof10];

function FloatingCta() {
  const [visible, setVisible] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const distanceFromBottom = docHeight - scrollY - winHeight;
      setVisible(scrollY > 700 && distanceFromBottom > 200);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <div className={`${styles.wrap} ${visible ? styles.show : ''}`}>
        <div className={styles.shelf}>
          <button className={styles.btn} onClick={() => setIsFormOpen(true)}>
            <span className={styles.shine} />
            <div className={styles.ctaContent}>
              <div className={styles.proofAvatars}>
                {proofImages.map((src, i) => (
                  <img key={i} src={src} alt="" className={styles.proofAvatar} />
                ))}
              </div>
              <span className={styles.text}>
                לחצי כאן והצטרפי לעוד עשרות נשים שהפכו לבוס של עצמן
              </span>
            </div>
          </button>
        </div>
      </div>

      <FormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
}

export default FloatingCta;
